/* R148d · Feb 2026 — Small chip that surfaces the schedule health of a
 * task at a glance next to the Plan block heading. Shows a compact
 * label like "5d late" / "2d early" / "on time" based on the task's
 * pre-computed variance days from effort_service. */
export default function PlanVsActualChip({ task }) {
  if (!task) return null;
  // Prefer completion variance (final signal); fall back to start variance.
  const cv = task.completion_variance_days;
  const sv = task.start_variance_days;
  const v = cv != null ? cv : sv;
  if (v == null) return null;
  // R148g · Feb 2026 — Distinguish "days to go" (open, not yet due) from
  // "days early" (already delivered before due date). "Early" only when
  // the actual date is set — otherwise it's still ahead of schedule.
  const isFinalized = cv != null
    ? !!task.actual_end_date
    : !!task.actual_start_date;
  const cls = v > 0
    ? "border-red-500 text-red-700 bg-red-50"
    : v < 0
      ? (isFinalized ? "border-emerald-500 text-emerald-700 bg-emerald-50" : "border-sky-500 text-sky-700 bg-sky-50")
      : "border-border text-muted-foreground bg-muted/40";
  const label = v > 0
    ? `${v}d late`
    : v < 0
      ? (isFinalized ? `${-v}d early` : `${-v}d to go`)
      : "on time";
  return (
    <span
      className={`inline-block border px-1.5 py-0.5 text-[10px] font-semibold ${cls}`}
      title={cv != null ? "Actual completion vs Due date" : "Actual start vs Start date"}
      data-testid="plan-vs-actual-chip"
    >
      {label}
    </span>
  );
}
